import { StdMapTileLayerFactory } from "./StdMapTileLayerFactory";
import { BlankMapTileLayerFactory } from "./BlankMapTileLayerFactory";
import { SeamlessphotoMapTileLayerFactory } from "./SeamlessphotoMapTileLayerFactory";
import { PaleMapTileLayerFactory } from "./PaleMapTileLayerFactory";
import { RoadStructuresBridgesLayerFactory } from "./RoadStructuresBridgesLayerFactory";
import { RoadStructuresTunnelsLayerFactory } from "./RoadStructuresTunnelsLayerFactory";
import { RoadStructuresShedsLayerFactory } from "./RoadStructuresShedsLayerFactory";
import { RoadStructuresCulvertsLayerFactory } from "./RoadStructuresCulvertsLayerFactory";
import { RoadStructuresPedestrianDecksLayerFactory } from "./RoadStructuresPedestrianDecksLayerFactory";
import { RoadStructuresOverheadSignagesLayerFactory } from "./RoadStructuresOverheadSignagesLayerFactory";
import { RoadStructuresPavementsLayerFactory } from "./RoadStructuresPavementsLayerFactory";
import { RoadStructuresEarthworksLayerFactory } from "./RoadStructuresEarthworksLayerFactory";
import { DrmNodeMapLayerFactory } from "./DrmNodeMapLayerFactory";
import { DrmLinkMapLayerFactory } from "./DrmLinkMapLayerFactory";
import { TraVosLayerFactory } from "./TraVosLayerFactory";
import { ODSumDeparturesLayerFactory } from "./ODSumDeparturesLayerFactory";
import { ODZoneLayerFactory } from "./ODZoneLayerFactory";
import { ILayerFactory } from "./ILayerFactory";
import { ETCLayerFactory } from "./ETCLayerFactory";
import { ODNodeLayerFactory } from "./ODNodeLayerFactory";
import { RoadAttributeLayerFactory } from "./RoadAttributeLayerFactory";
import { GeoJsonFactory } from "./GeoJsonFactory";

/**
 * layerFactotyマップクラス
 */
export class LayerFactory {
  /**
   * 全レイヤファクトリ取得
   */
  getLayerFactory(): Array<ILayerFactory> {
    const array = new Array<ILayerFactory>();
    array.push(this.StdMapTile);
    array.push(this.BlankMapTile);
    array.push(this.SeamlessphotoMapTile);
    array.push(this.PaleMapTile);
    array.push(this.GeoJson);
    array.push(this.ODDepartureAndArrival);
    array.push(this.ODZone);
    array.push(this.ODNode);
    array.push(this.DrmLinkMap);
    array.push(this.DrmNodeMap);
    array.push(this.RoadAttribute);
    array.push(this.ETC);
    array.push(this.RoadStructuresEarthworks);
    array.push(this.RoadStructuresPavements);
    array.push(this.RoadStructuresOverheadSignages);
    array.push(this.RoadStructuresPedestrianDecks);
    array.push(this.RoadStructuresCulverts);
    array.push(this.RoadStructuresSheds);
    array.push(this.RoadStructuresTunnels);
    array.push(this.RoadStructuresBridges);
    array.push(this.TraVos);
    return array;
  }

  /** 国土地理院標準地図 */
  StdMapTile = new StdMapTileLayerFactory();
  /** 国土地理院白地図 */
  BlankMapTile = new BlankMapTileLayerFactory();
  /** 国土地理院航空写真 */
  SeamlessphotoMapTile = new SeamlessphotoMapTileLayerFactory();
  /** 国土地理院淡色地図 */
  PaleMapTile = new PaleMapTileLayerFactory();

  /** 点検データ（道路橋） */
  RoadStructuresBridges = new RoadStructuresBridgesLayerFactory();
  /** 点検データ（トンネル） */
  RoadStructuresTunnels = new RoadStructuresTunnelsLayerFactory();
  /** 点検データ（シェッド） */
  RoadStructuresSheds = new RoadStructuresShedsLayerFactory();
  /** 点検データ（大型カルバート） */
  RoadStructuresCulverts = new RoadStructuresCulvertsLayerFactory();
  /** 点検データ（横断歩道橋） */
  RoadStructuresPedestrianDecks =
    new RoadStructuresPedestrianDecksLayerFactory();
  /** 点検データ（門型標識等） */
  RoadStructuresOverheadSignages =
    new RoadStructuresOverheadSignagesLayerFactory();
  /** 点検データ（舗装） */
  RoadStructuresPavements = new RoadStructuresPavementsLayerFactory();
  /** 点検データ（特定道路⼟⼯構造物） */
  RoadStructuresEarthworks = new RoadStructuresEarthworksLayerFactory();

  /** DRMノードレイヤ */
  DrmNodeMap = new DrmNodeMapLayerFactory();
  /** DRMリンクレイヤ */
  DrmLinkMap = new DrmLinkMapLayerFactory();
  /** ETCレイヤ */
  ETC = new ETCLayerFactory();

  /** TraVosレイヤ */
  TraVos = new TraVosLayerFactory();

  /** OD量レイヤ */
  ODNode = new ODNodeLayerFactory();
  /** OD発集量レイヤ */
  ODDepartureAndArrival = new ODSumDeparturesLayerFactory();
  /** ODゾーン */
  ODZone = new ODZoneLayerFactory();

  /** 道路属性 */
  RoadAttribute = new RoadAttributeLayerFactory();

  /** ベクタ読み込み */
  GeoJson = new GeoJsonFactory();
}
